import {
  $create, $put, $patch, $delete,
} from '~/api/client';

export function create({ attributes }, { config = {} } = {}) {
  return $create('members', {
    type: 'member',
    attributes,
  }, config);
}

export function acceptTos(user, { config = {} } = {}) {
  return $create('members/tos-validate', {
    type: 'member',
    id: user.id,
    attributes: {},
  }, config);
}

export function patchPhone(id, { attributes }, { config = {} } = {}) {
  return $patch(`members/${id}/phone`, {
    id,
    type: 'member',
    attributes,
  }, config);
}

export function patch({
 id, attributes, relationships = undefined,
}, { config = {} } = {}) {
  return $patch(`members/${id}`, {
    id,
    type: 'member',
    attributes,
    relationships,
  }, config);
}

export function confirmPhone(id, code, { config = {} } = {}) {
  return $create(`members/${id}/phone/verify`, {
    id,
    type: 'member',
    attributes: {
      code,
    },
  }, config);
}

export function verifyEmail(code, { config = {} } = {}) {
  return $create('members/verify-email', {
    type: 'member',
    attributes: {
      token: code,
    },
  }, config);
}

export function requestPassword(email, { config = {} } = {}) {
  return $create('members/forgot-password', {
    type: 'member',
    attributes: {
      email,
    },
  }, config);
}

export function resetPassword({ attributes }, { config = {} } = {}) {
  return $create('members/reset-password', {
    type: 'member',
    attributes,
  }, config);
}

export function destroy(id, { config = {} } = {}) {
  return $delete('members', id, config);
}

export function syncRoles({ id: memberId, roles = [] }) {
  return $put(`/v2/members/${memberId}/relationships/roles`, {
    data: roles.map((id) => ({
      type: 'role',
      id,
    })),
  });
}

export function syncEquipment({ id: memberId, equipment = [] }) {
  return $put(`/v2/members/${memberId}/relationships/equipment`, {
    data: equipment.map((id) => ({
      type: 'equipment',
      id,
    })),
  });
}

export function createNewEquipment({ id: memberId, newEquipment = [] }) {
  return $create(`members/${memberId}/relationships/equipment`,
    newEquipment.map(({ equipment_type, description }) => ({
      type: 'equipment',
      equipment_type,
      description,
    })));
}

export function syncSubtypes({ id: memberId, subtypes = [] }) {
  return $put(`/v2/members/${memberId}/relationships/subtypes`, {
    data: subtypes.map((id) => ({
      type: 'product_subtype',
      id,
    })),
  });
}

export function syncSpokenLanguages({ id: memberId, languages = [] }) {
  return $put(`/v2/members/${memberId}/relationships/spoken-languages`, {
    data: languages.map((language) => ({
      type: 'language',
      code: language.key,
    })),
  });
}
